import { render, staticRenderFns } from "./TText.vue?vue&type=template&id=696e582d&scoped=true"
import script from "./TText.vue?vue&type=script&lang=ts"
export * from "./TText.vue?vue&type=script&lang=ts"
import style0 from "./TText.vue?vue&type=style&index=0&id=696e582d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e582d",
  null
  
)

export default component.exports